module.exports = __webpack_public_path__ + "img/cxTrends-4.a8dc380f.png";